<template>
  <nav
    class="breadcrumbs"
    :class="{ 'is--empty': isEmpty }"
    role="navigation"
    :aria-label="ariaLabel"
  >
    <a
      v-for="(breadcrumb, index) of breadcrumbs"
      :key="`breadcrumb-${index}`"
      class="breadcrumbs__breadcrumb"
      :href="breadcrumb.url"
      :title="breadcrumb.title"
      @click="trackClick(breadcrumb)"
    >
      <span
        class="breadcrumbs__text"
        v-text="breadcrumb.title"
      />
      <span
        v-if="index < breadcrumbs.length"
        class="breadcrumbs__separator is-hidden--mobile"
      >/</span>
      <svg
        class="breadcrumbs__separator is-hidden--desktop"
        width="5"
        height="7"
        viewBox="0 0 5 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      ><path
        d="M1 0.495807L4.01699 3.5128L1 6.52979"
        stroke="#090909"
      /></svg>
    </a>
    <p
      v-if="title"
      class="breadcrumbs__title"
    >
      {{ title }}
    </p>
  </nav>
</template>

<script>

/**
 * Vue: breadcrumbs (bread-crumbs)
 * -----------------------------------------------------------------------------
 * breadcrumbs.
 *
 */
export default {
  name: 'BreadCrumbs',

  props: {
    merchant: {
      type: String,
      default: '',
    },
    collection: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      ariaLabel: 'breadcrumb',
      title: '',
      breadcrumbs: [],
      isEmpty: false,
    }
  },

  mounted() {
    this.getBreadCrumbs()
  },

  methods: {
    async getBreadCrumbs() {
      try {
        // Build the query
        const url = new URL(`https://api.depict.ai/v3/listings/external_id/${this.collection.handle}`)
        const params = new URLSearchParams(url.search)

        const queryObject = {
          merchant: this.merchant,
          market: cnvs.store.country.toLowerCase(),
          locale: cnvs.store.language,
        }

        Object.keys(queryObject).forEach(key => {
          params.set(key, queryObject[key])
        })

        url.search = params.toString()

        // Call the api
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })

        // Deconstruct the response for the data
        const {
          ancestors = [],
          title,
          show_in_breadcrumbs: showCurrent = true,
        } = await response.json()

        // Build out the breadcrumb array
        const crumbs = []

        if (ancestors.length > 0) {
          ancestors.forEach((item) => {
            if (item.show_in_breadcrumbs) {
              crumbs.push({
                url: `/collections/${item.slug}`,
                title: item.title,
              })
            }
          })
        }

        // Set the data
        this.breadcrumbs = crumbs
        this.title = showCurrent ? title : ''

        if (this.breadcrumbs.length === 0 && this.title === '') {
          this.isEmpty = true
        }

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.message)
      }
    },

    trackClick(breadcrumb) {
      const dataLayer = window.dataLayer || []

      dataLayer.push({
        event: 'breadcrumb_click',
        target_text: breadcrumb.title,
      })
    },
  },
}
</script>

<style lang="scss">
@import './bread-crumbs';
</style>
